import { createTheme, ThemeOptions, ThemeProvider } from '@mui/material';
import { grey } from '@mui/material/colors';
import { svSE } from '@mui/material/locale';
import * as React from 'react';

const opts: ThemeOptions = {
  palette: {
    primary: {
      main: '#f26432',
      light: '#fff6ee',
    },
  },
  typography: {
    fontFamily: 'Nunito Sans,Calibri,"Trebuchet MS",Verdana,Arial,sans-serif',
    h5: {
      fontWeight: 'bolder',
    },
  },
  components: {
    MuiTypography: {
      styleOverrides: {
        subtitle1: {
          fontWeight: 600,
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        // Name of the slot
        root: {
          height: '37px',
          fontWeight: 700,
          textTransform: 'none',
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          '&.Mui-selected': {},
          fontWeight: 700,
          textTransform: 'none',
        },
        textColorInherit: true,
      },
    },
    MuiButtonBase: {
      styleOverrides: {
        root: {
          backgroundColor: 'inherit',
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          color: grey[600],
          '&.Mui-checked': {
            color: grey[700],
          },
        },
      },
    },
  },
};

const theme = createTheme(opts, svSE);

const MetriaThemeProvider = (props: React.PropsWithChildren<any>) => (
  <ThemeProvider theme={theme}>{props.children}</ThemeProvider>
);

export default MetriaThemeProvider;

